@import (reference) '../../../styles/variables.less';
@import (reference) '../../../styles/functions.less';
@import (reference) '../../../styles/buttons.less';
@import (reference) '../../../styles/themes.less';

:host {
  display: block;
  font: @lt-font-primary;
}

.theme-white {
  .theme-white();
}

.theme-blue-light {
  .theme-blue-light();
}

.theme-blue-deep {
  .theme-blue-deep();
}

.theme-teal {
  .theme-teal();
}

.h1,
.h3 {
  margin: 0;
  padding: 0;
}

.h1 {
  font: @lt-font-secondary;
  .font-size-em(24);
  .line-height(30, 24);

  @container main (width >=@container-sm) {
    .font-size-em(28);
    .line-height(36, 28);
  }


  @container main (width >=@container-md) {
    .font-size-em(34);
    .line-height(41, 34);
  }
}

.h3 {
  font-weight: bold;
  .font-size-em(21);
  .line-height(30, 21);

  @container main (width >=@container-sm) {
    .font-size-em(24);
    .line-height(29, 24);
  }


  @container main (width >=@container-md) {
    .font-size-em(27);
    .line-height(36, 27);
  }
}

.container {
  background-color: var(--background-color);
  border-radius: @spacer-2;
  box-shadow: @shadow-1;
  color: var(--font-color);
  container-name: main;
  container-type: inline-size;
  display: block;
  margin: 0 auto;
  max-width: @container-max;
  padding: @spacer-3;
}

.cta-btn {
  .button-common();
  .button-size-medium();

  align-self: center;
  background-color: var(--btn-color);
  box-shadow: var(--btn-border) var(--btn-color-border);
  color: var(--btn-text);
  height: 41px;

  &:hover {
    background-color: var(--btn-color-hover);
    box-shadow: var(--btn-border-hover) var(--btn-color-border-hover);
  }

  &:focus {
    background-color: var(--btn-color-focus);
    box-shadow: var(--btn-border-focus) var(--btn-color-border-focus);
  }

  &:disabled {
    background-color: @lt-gray-light-2;
    color: @lt-gray-dark-2;
  }
}

header {
  color: var(--font-head-color);
  text-align: left;

  @container main (width >=@container-md) {
    text-align: center;
  }
}

.form-container {
  display: flex;
  gap: @spacer-2;
  justify-content: center;
  padding-bottom: @spacer-3;
  padding-top: @spacer-3;

  @container main (width >=@container-sm) {
    gap: @spacer-3;
  }

  @container main (width >=@container-md) {
    gap: @spacer-4;
  }

  &--double-input {
    align-items: center;
    flex-direction: column;
    gap: @spacer-3;

    @container main (width >=@container-sm) {
      flex-direction: row;
    }
  }
}

.inputs-container {
  flex-grow: 1;
  max-width: 300px;
  place-self: stretch;

  ltc-input-text {
    color: @lt-blue-deep;
    flex-grow: 1;
    min-width: 120px;

    label {
      color: @lt-gray-dark-2;
    }
  }

  &--double-input {
    display: flex;
    gap: @spacer-4;
    max-width: 100%;

    @container main (width >=@container-sm) {
      max-width: 400px;
    }
  }
}

footer {
  align-items: center;
  display: flex;
  justify-content: center;
}
